import { parseJwtPayload } from '~/types/permission/Types';
import { Base, FetchingServices } from './base';

interface IUser {
  adphone?: string;
  adsub?: string;
  aud?: string;
  dtkn?: string;
  email?: string;
  exp?: number;
  iat?: number;
  nickname?: string;
  phone?: string;
  sub?: string;
}

class CCurrentUser extends Base {
  private uuid: string = '';
  private role: string = '';
  private user: IUser = {
    adphone: '',
    adsub: '',
    aud: '',
    dtkn: '',
    email: '',
    exp: 0,
    iat: 0,
    nickname: '',
    phone: '',
    sub: '',
  };

  public get getUuid(): string {
    return this.uuid;
  }

  public setUserInfo() {
    this.user = parseJwtPayload();
    this.user.sub ? (this.uuid = this.user.sub) : (this.uuid = '');
    this.setRole();
    console.log(
      `%cRole -> ${this.role} ${this.uuid}`,
      'color: white; background-color: #007acc; padding: 4px 8px; border-radius: 4px; font-size: 14px;'
    );
  }

  public get getUserInfo(): IUser {
    return this.user;
  }

  private setRole() {
    this.user.adsub ? (this.role = 'agent') : (this.role = 'admin');
  }

  public get getRole(): string {
    return this.role;
  }

  public async getUserMainUuidApi(): Promise<string> {
    const jwtData = parseJwtPayload();

    // admin uuid is ok no need to byId from api
    if (!jwtData.adsub) {
      return jwtData.sub;
    }

    try {
      const response = await this.get<{ uuid: string }>(
        FetchingServices.ipbx,
        'nnava-number/engaged/uuid/' + jwtData.sub
      );

      return response?.data?.uuid;
    } catch (error) {
      console.log(error);
      return '';
    }
  }

  public reset() {
    this.role = '';
    this.user = {
      adphone: '',
      adsub: '',
      aud: '',
      dtkn: '',
      email: '',
      exp: 0,
      iat: 0,
      nickname: '',
      phone: '',
      sub: '',
    };
  }
}

export const currentUser = reactive(new CCurrentUser());
